import { createAction } from "@reduxjs/toolkit";
import { fetchUserData } from "./apps/userData/UserDataSlice";
import { fetchMeetingsThunk } from "./apps/meetings/MeetingDataSlice";
import { fetchAvailability } from "./apps/availability/AvailabilityDataSlice";

// Single action to reset all store data
export const resetAllStoreData = createAction("store/resetAllData");

// Thunk to reset and reload all user data
export const resetAndReloadAllData = () => async (dispatch, getState) => {
  // First reset all data
  dispatch(resetAllStoreData());

  // Then fetch fresh data for the impersonated user
  await dispatch(fetchUserData(true)); // Force reload even if hasFetched is true
  await dispatch(fetchMeetingsThunk());

  // Wait for user data to load, then fetch availability
  await dispatch(fetchAvailability());
};
